import { HttpService } from 'services/HttpService';
import { BaseUserModel } from 'models/BaseUserModel';
import { DetailedUserModel } from 'models/DetailedUserModel';

export class UserService {
  static baseUrl = '/frontend';

  static async getUsers(): Promise<BaseUserModel[]> {
    return HttpService.get(`${UserService.baseUrl}/access/users/list`);
  };

  static async getDetailedUser(email: string): Promise<DetailedUserModel> {
    return HttpService.get(`${UserService.baseUrl}/access/users?email=${email}`);
  };

  static async create(user: {name: string, surname: string, email: string}): Promise<{ok: string}> {
    return HttpService.post(`${UserService.baseUrl}/access/users`, user);
  };

  static async enable(email: string): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/enable?email=${email}`);
  };

  static async disable(email: string): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/disable?email=${email}`);
  };

  static async assignRole(email: string, role: string): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/role/assign`, {
      email,
      role
    });
  };

  static async revokeRole(email: string, role: string): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/role/revoke`, {
      email,
      role
    });
  };

  static async removeOperatorFromManager(email: string, operators: string[]): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/operators/remove?manager=${email}`, { operators });
  };

  static async addOperatorForManager(email: string, operators: string[]): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/operators/assign?manager=${email}`, { operators });
  };

  static async resetPassword(email: string): Promise<{ok: string}> {
    return HttpService.put(`${UserService.baseUrl}/access/users/resetpassword?email=${email}`);
  };
}
